import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { MuiThemeProvider, StylesProvider } from '@material-ui/core';
import { bootstrapAwareTheme } from '%evp_theme/brandbook/material/theme';
import store from '%evp_ticket_frontend/js/redux/store';
import history from '%evp_ticket_frontend/js/redux/history';
import routes from '%evp_ticket_frontend/js/react/config/routes';
import Snackbar from '%app/js/common/components/material/Snackbar';
import configureTextDirection from '%app/js/common/components/material/service/configureTextDirection';
import CookieAgreementCard from '%paysera_service_agreement/js/CookiesUserAgreement/component/CookieAgreementCard';

function Page() {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <StylesProvider jss={configureTextDirection()}>
                    <MuiThemeProvider theme={bootstrapAwareTheme}>
                        <CookieAgreementCard />
                        <Snackbar />
                        <Switch>
                            {routes.map(route => (
                                <Route path={route.path} render={route.component} key={route.path} />
                            ))}
                        </Switch>
                    </MuiThemeProvider>
                </StylesProvider>
            </ConnectedRouter>
        </Provider>
    );
}

export default React.memo(Page);
